module.exports = __webpack_public_path__ + "static/media/arrow-ampliar-icon.9e593729.svg";